import { defineStore } from 'pinia'

interface SnackbarMessage {
	text: string
	type: 'error' | 'warning' | 'info' | 'success' | null | undefined
}

export const useSnackbarStore = defineStore('snackbar', {
	state: () => ({
		messages: [
			{
				text: 'Hello World',
				type: 'error'
			}
		] as SnackbarMessage[]
	}),
	getters: {
		getMessages: (state) => state.messages
	},
	actions: {
		showSnackbar(message: SnackbarMessage) {
			if (!message?.text) {
				return
			}
			let text = message.text
			text = text[0].toUpperCase() + text.slice(1)
			message.text = text
			this.messages.push(message)
		}
	}
})
